import * as React from 'react';

import GlobalStyles from '@mui/joy/GlobalStyles';
import Box from '@mui/joy/Box';


import media from './media.json'

function App() {




  return (
    <>
    <GlobalStyles
      styles={(theme) => ({
        "body, html": {
          margin: 0,
          padding: 0
        },
        ".App": {
          width: '100dvw',
          height: '100dvh',
          backgroundImage: `url('media/${media.background['1920']}')`,
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover',
          backgroundPosition: 'center center'
        },


        '#main-container': {
          display: 'flex',
          width: '1900px',
          height: '100%',
          margin: '0 auto'
        },

        '#middle-container': {
          width: '1200px',
        },

        '#left-container, #right-container': {
          width: '350px',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center center'
        },

        '#top-line': {
          width: '100%',
          height: 15
        },

        "#left-container": {
          backgroundImage: `url('media/${media.left['350']}')`
        },

        "#right-container": {
          backgroundImage: `url('media/${media.right['350']}')`
        },




        "@media screen and (max-width: 1920px)": {
          "#left-container": {
            backgroundImage: `url('media/${media.left['300']}')`,
            width: 300
          },

          "#right-container": {
            backgroundImage: `url('media/${media.right['300']}')`,
            width: 300
          },

          "#main-container": {
            width: '1800px'
          }
        },

        "@media screen and (max-width: 1800px)": {
          "#left-container": {
            backgroundImage: `url('media/${media.left['200']}')`,
            width: 200
          },

          "#right-container": {
            backgroundImage: `url('media/${media.right['200']}')`,
            width: 200
          },

          "#main-container": {
            width: '1600px'
          }
        },
        "@media screen and (max-width: 1600px)": {
          "#left-container": {
            backgroundImage: `url('media/${media.left['150']}')`,
            width: 150
          },

          "#right-container": {
            backgroundImage: `url('media/${media.right['150']}')`,
            width: 150
          },

          "#main-container": {
            width: '1500px'
          }
        },
        "@media screen and (max-width: 1500px)": {
          "#left-container": {
            backgroundImage: `url('media/${media.left['100']}')`,
            width: 100
          },

          "#right-container": {
            backgroundImage: `url('media/${media.right['100']}')`,
            width: 100
          },

          "#main-container": {
            width: '1400px'
          }
        },
        "@media screen and (max-width: 1400px)": {
          "#left-container": {
            backgroundImage: `url('media/${media.left['60']}')`,
            width: 60
          },

          "#right-container": {
            backgroundImage: `url('media/${media.right['60']}')`,
            width: 60
          },

          "#main-container": {
            width: '1320px'
          }
        },

        "@media screen and (max-width: 1320px)": {
          "#left-container, #right-container": {
            display: 'none'
          },

          "#main-container, #middle-container": {
            flex: 1, 
            width: '100%'
          }
        },

        '#top-container': {
          backgroundImage: `url('media/${media.top['1200']}')`,
          backgroundRepeat: 'no-repeat',
          width:1200,
          height:218,
          margin:'auto'
        },


        "@media screen and (max-width: 1200px)": {
          '#top-container': {
            backgroundImage: `url('media/${media.top['1100']}')`,
            width:1100
          }
        },

        "@media screen and (max-width: 1100px)": {
          '#top-container': {
            backgroundImage: `url('media/${media.top['1000']}')`,
            width:1000
          }
        },

        "@media screen and (max-width: 1000px)": {
          '#top-container': {
            backgroundImage: `url('media/${media.top['900']}')`,
            width:900,
            height:200,
          }
        },

        "@media screen and (max-width: 900px)": {
          '#top-container': {
            backgroundImage: `url('media/${media.top['720']}')`,
            width:720,
            height:150,
            backgroundPosition: 'center center'
          }
        },
        "@media screen and (max-width: 720px)": {
          '#top-container': {
            backgroundImage: `url('media/${media.top['640']}')`,
            width:640,
            height:138
          }
        },

        "@media screen and (max-width: 640px)": {
          '#top-container': {
            backgroundImage: `url('media/${media.top['480']}')`,
            width:'100%'
          }
        },

        "@media screen and (max-width: 1366px)": {
          ".App": {
            backgroundImage: `url('media/${media.background['1366']}')`
          }
        },
        "@media screen and (max-width: 960px)": {
          ".App": {
            backgroundImage: `url('media/${media.background['960']}')`
          }
        },

        "@media screen and (max-width: 480px)": {
          ".App": {
            backgroundImage: `url('media/${media.background['480']}')`
          },

          '#top-container': {
            height:85,
            width:'100%',
            backgroundSize:'100%'
          }
        }

      })}
    />

    <div className="App">
      <Box id={'main-container'}>
        <Box id="left-container" />

        <Box id="middle-container">
          <Box id="top-line" />
          <Box id="top-container" />
          <Box id="site-container" />
        </Box>

        <Box id="right-container" />
      </Box>
    </div>
    </>
  );
}

export default App;
